import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=772b6aa3&scoped=true&"
import script from "./Presupuestos.vue?vue&type=script&lang=js&"
export * from "./Presupuestos.vue?vue&type=script&lang=js&"
import style0 from "./Presupuestos.vue?vue&type=style&index=0&id=772b6aa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b6aa3",
  null
  
)

export default component.exports